import { useEffect } from 'react';
import { DialogComponent, showDialog } from '@lingoda/dialogs';
import { useDispatch } from '@lingoda/hooks';
import { isItTimeToShowPostFFreeTrialDialog } from '@lingoda/f-free-trial-utils';
import { createDate, isAfter } from '@lingoda/dates';
import { isSubscriptionFFreeTrial } from '@lingoda/f-free-trial';
import { useUserSubscriptionsQuery } from '@lingoda/graphql';

export const usePostFFreeTrialDialog = () => {
    const dispatch = useDispatch();
    const userSubscriptions = useUserSubscriptionsQuery();
    const currentSubscription = userSubscriptions.data?.subscriptions?.currentSubscription;
    const latestSubscription = userSubscriptions.data?.subscriptions?.latestSubscription;

    useEffect(() => {
        if (
            (isSubscriptionFFreeTrial(currentSubscription) ||
                (!currentSubscription && isSubscriptionFFreeTrial(latestSubscription))) &&
            isItTimeToShowPostFFreeTrialDialog()
        ) {
            if (currentSubscription && currentSubscription?.expiresAt) {
                const expiresAt = createDate(currentSubscription.expiresAt);
                const now = createDate();
                const isExpire = isAfter(now, expiresAt);

                if (isExpire) {
                    dispatch(showDialog(DialogComponent.PostFFreeTrialDialog));
                }
            } else {
                dispatch(showDialog(DialogComponent.PostFFreeTrialDialog));
            }
        }
    }, [dispatch, currentSubscription, latestSubscription]);
};
